module.exports = __webpack_public_path__ + "img/logo-aica-hotel.bd660e0a.png";